import { render, staticRenderFns } from "./AppContactEmbedded.vue?vue&type=template&id=5fdab1c3&"
import script from "./AppContactEmbedded.vue?vue&type=script&lang=ts&"
export * from "./AppContactEmbedded.vue?vue&type=script&lang=ts&"
import style0 from "./AppContactEmbedded.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports